// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"308ad281","346":"ab82233d"}[chunkId] + ".chunk.css";
};